
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {RushBufferDocument} from "@/models/buffer.model";
import {deleteRush, fetchRushs} from "@/axios/repository/buffer.axios";
import SbEditRushDialog from "@/components/stead/workspaces/stepbuilder/dialogboxes/sbEditRushDialog.vue";
@Component({
  components: {SbEditRushDialog}
})
export default class SbSelectRushDialog extends Vue {
  // Les props
  @Prop({default: false}) private editmode!: boolean

  // Les propriétés
  private isVisible: boolean = false
  private loading: boolean = false
  private rushs: RushBufferDocument[] = []
  private hover: string = ''
  private searchText: string = ''
  private filteredRushs: RushBufferDocument[] = []
  private showEditDialog: boolean = false
  private editRush: RushBufferDocument | null = null

  // Les propriétés calculées
  private get prjid(): string | null {
    const prj = this.$store.state.current.Project
    return prj ? prj._id : null
  }

  // Les hooks
  // Les méthodes surveillées
  @Watch('isVisible')
  private async onVisible() {
    if (this.prjid != null) {
      this.loading = true
      this.rushs = await fetchRushs(this.prjid)
      this.filteredRushs = [...this.rushs]
      this.loading = false
    }
  }

  // Les méthodes d'instance
  private onClose() {
    this.isVisible = false
    this.$emit('cancel')
  }

  private onClick(rush: RushBufferDocument) {
    if (!this.editmode) {
      this.$emit('steps', rush.steps)
      this.isVisible = false
    }
  }

  private onKeyDown() {
    if (this.searchText.length > 0) {
      const search = this.searchText.toLowerCase()
      this.filteredRushs = this.rushs.filter(r => r.name.toLowerCase().includes(search) || r.description.toLowerCase().includes(search))
    } else {
      this.filteredRushs = [...this.rushs]
    }
  }

  private onShowEdit(rush: RushBufferDocument) {
    this.showEditDialog = true
    this.editRush = rush
  }

  private async onDelete(rush: RushBufferDocument) {
    await deleteRush(rush._id)
    await this.onVisible()
  }

  // Les méthodes statiques
}
